import { render, staticRenderFns } from "./PaymentRecordsTableNew.vue?vue&type=template&id=06c03738&scoped=true"
import script from "./PaymentRecordsTableNew.vue?vue&type=script&lang=ts"
export * from "./PaymentRecordsTableNew.vue?vue&type=script&lang=ts"
import style0 from "./PaymentRecordsTableNew.vue?vue&type=style&index=0&id=06c03738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c03738",
  null
  
)

export default component.exports